<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Конструктор писем</div>
        </div>
    </div>
    <div id="letter_construct_input" class="letter_construct" style="display:block">
		<div class="mb-4">
			<label class="form-label">Тема письма</label>
			<input class="form-control" type="text" id="title_input"/>
		</div>

		<div class="mb-4 editor_container">
			<label class="form-label">Текст или воспользуйтесь <a href="#" @click.prevent="showPattern">шаблоном</a></label>
			<QuillEditor :modules="modules" theme="snow" toolbar="full"/>
			<div class="pattern_container" id="pattern_block" style="display:none">
				<div class="pattern_inner" @click.prevent="addErrorPattern">Письмо об ошибке</div>
				<div class="pattern_inner" @click.prevent="addRecoveryPattern">Письмо о восстановлении</div>
				<div class="pattern_inner" @click.prevent="addInfoPattern">Письмо информирование</div>
			</div>
		</div>


		<div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
			<button class="btn btn-lg btn-primary me-3" @click.prevent="save">Сохранить</button>
		</div>
	</div>
	<div id="letter_construct_output" style="display:none">
		<div class="mb-4">
			<label class="form-label">Полученный HTML</label>
			<textarea readonly id="resultHTML" style="resize:none;width:100%;height: 250px;"></textarea>
		</div>

		<div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
			<button class="btn btn-lg btn-primary me-3" @click.prevent="newLetter">Новое письмо</button>
		</div>
	</div>

	<Alert />
</template>

<style>
	.letter_construct .pattern_container {
		display: block;
		position: absolute;
		top: 30px;
		left: 260px;
		background-color: #fff;
		border: 1px solid #D1D1D1;
		border-radius: 5px;
	}

	.letter_construct .pattern_inner {
		line-height: 38px;
		padding: 0 24px;
		cursor: pointer;
		border-bottom: 1px solid #ddd;
	}

	.letter_construct .pattern_inner:hover {
		background-color: #1aa2fd;
		color: #fff;
	}

	.letter_construct .editor_container {
		position: relative;
	}
</style>

<script>
	import { ref, defineComponent } from 'vue';
	import { QuillEditor } from '@vueup/vue-quill';
	import '@vueup/vue-quill/dist/vue-quill.snow.css';
	import ImageUploader from 'quill-image-uploader';
	import axios from 'axios';
	import Alert from '../../alerts/Alert.vue';
	import { mapMutations } from 'vuex/dist/vuex.cjs.js';

	export default defineComponent({
		components: {
			QuillEditor,
			Alert
		},
		data: function () {
        return {
            alertMessage: '',
        };
    },
		setup: () => {

			const modules = {
				name: 'imageUploader',
				module: ImageUploader,
				options: {
					upload: file => {
						return new Promise((resolve, reject) => {
							const formData = new FormData();
							formData.append("image", file);
							formData.append("resize", 580);
							axios.post('/technical/letter-constructor/upload', formData)
								.then(res => {
									if(res.data.status == 'ok') {
										resolve(res.data.url);
									} else {
										this.addAlert({ type: 'error', title: 'Ошибка', text: res.data.message });
										reject("Upload failed");
									}
								})
								.catch(err => {
									reject("Upload failed");
								})
						})
					}
				}
			}
			return { modules }

		},

		methods: {
			...mapMutations('alerts', ['addAlert']),

			save: function () {

				var objects = document.getElementsByClassName('ql-align-center');
				for(var obj of objects) {
					obj.style.textAlign = 'center';
					obj.classList.remove('ql-align-center');
				}

				var objects = document.getElementsByClassName('ql-align-right');
				for(var obj of objects) {
					obj.style.textAlign = 'right';
					obj.classList.remove('ql-align-right');
				}

				var objects = document.getElementsByClassName('ql-align-justify');
				for(var obj of objects) {
					obj.style.textAlign = 'justify';
					obj.classList.remove('ql-align-justify');
				}

				var objects = document.getElementsByClassName('ql-indent-1');
				for(var obj of objects) {
					obj.style.paddingLeft = '3em';
					obj.classList.remove('ql-indent-1');
				}

				var objects = document.getElementsByClassName('ql-indent-2');
				for(var obj of objects) {
					obj.style.paddingLeft = '6em';
					obj.classList.remove('ql-indent-2');
				}

				var objects = document.getElementsByClassName('ql-indent-3');
				for(var obj of objects) {
					obj.style.paddingLeft = '9em';
					obj.classList.remove('ql-indent-3');
				}

				var objects = document.getElementsByClassName('ql-indent-4');
				for(var obj of objects) {
					obj.style.paddingLeft = '12em';
					obj.classList.remove('ql-indent-4');
				}

				var objects = document.getElementsByClassName('ql-indent-5');
				for(var obj of objects) {
					obj.style.paddingLeft = '15em';
					obj.classList.remove('ql-indent-5');
				}

				var objects = document.getElementsByClassName('ql-indent-6');
				for(var obj of objects) {
					obj.style.paddingLeft = '18em';
					obj.classList.remove('ql-indent-6');
				}

				var objects = document.getElementsByClassName('ql-indent-7');
				for(var obj of objects) {
					obj.style.paddingLeft = '21em';
					obj.classList.remove('ql-indent-7');
				}

				var objects = document.getElementsByClassName('ql-indent-8');
				for(var obj of objects) {
					obj.style.paddingLeft = '24em';
					obj.classList.remove('ql-indent-8');
				}

				var html = document.getElementsByClassName('ql-editor')[0].innerHTML;
				const title = document.getElementById('title_input').value;



				if(html.length > 0 && html != '<p><br></p>' && title.length > 0) {

					const letter_header = '<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><title>'+title+'</title></head><body style="width:100%;margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;"><table border="0" cellpadding="0" cellspacing="0" style="width:600px;max-width:100%;margin-top:0;margin-bottom:0;margin-right:auto;margin-left:auto;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-width:0;"><tbody><tr style="margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-width:0;" ><td style="margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:20px;padding-bottom:20px;padding-right:10px;padding-left:10px;border-width:0;" ><a href="https://d-services.ru" target="_blank" rel="noopener noreferrer"><img src="https://f.d-services.ru/web_assets/logo.png" alt="" style="max-width:100%;max-height:100%;width:242px;"></a></td></tr><tr style="margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-width:0;" ><td style="margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:10px;padding-bottom:10px;padding-right:0;padding-left:0;border-width:0;background-color:#0481D6;" ><p style="font-family:Arial, Helvetica, sans-serif;font-weight:500;font-size:16px;line-height:125%;color:#ffffff;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;text-align:center;" ><a href="https://d-services.ru/dev" target="_blank" rel="noopener noreferrer" style="text-decoration:none;color:#ffffff;padding-top:10px;padding-bottom:10px;padding-right:10px;padding-left:10px;display:inline-block;" >Услуги</a><a href="https://d-services.ru/complex" target="_blank" rel="noopener noreferrer" style="text-decoration:none;color:#ffffff;padding-top:10px;padding-bottom:10px;padding-right:10px;padding-left:10px;display:inline-block;" >Продукты</a><a href="https://d-services.ru/support" target="_blank" rel="noopener noreferrer" style="text-decoration:none;color:#ffffff;padding-top:10px;padding-bottom:10px;padding-right:10px;padding-left:10px;display:inline-block;" >Поддержка</a><a href="https://d-services.ru/contacts" target="_blank" rel="noopener noreferrer" style="text-decoration:none;color:#ffffff;padding-top:10px;padding-bottom:10px;padding-right:10px;padding-left:10px;display:inline-block;" >Контакты</a></p></td></tr><tr style="margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-width:0;" ><td style="font-family:Arial, Helvetica, sans-serif;font-weight:500;font-size:16px;line-height:125%;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:30px;padding-bottom:30px;padding-right:10px;padding-left:10px;border-width:0;" >';

					const letter_footer = '</td></tr></tbody> </table><table border="0" cellpadding="0" cellspacing="0" style="width:600px;max-width:100%;margin-top:0;margin-bottom:0;margin-right:auto;margin-left:auto;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-width:0;" ><tbody><tr style="margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-width:0;" ><td style="margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:30px;padding-bottom:30px;padding-right:10px;padding-left:10px;border-width:0;background-color:#000b16;background-position:center;background-size:cover;background-repeat:no-repeat;" ><div style="width:236px;max-width:100%;min-width:52%;float:left;margin-right:auto;padding-bottom:18px;"><a href="https://d-services.ru" target="_blank" rel="noopener noreferrer"><img src="https://f.d-services.ru/web_assets/logo-white.png" alt="" style="max-width:100%;max-height:100%;width:236px;"></a></div><div style="width:236px;max-width:100%;float:left;"><p style="font-family:Arial, Helvetica, sans-serif;font-weight:500;font-size:16px;line-height:131%;color:#FFFFFF;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:3px;padding-right:0;padding-left:0;" ><a href="tel:+74951463030" style="text-decoration:none;color:#FFFFFF;" ><img src="https://f.d-services.ru/web_assets/icon-phone.png" alt="" style="max-width:100%;max-height:100%;" ><span style="padding-left:4px;" >+7 (495) 146-30-30</span></a></p><p style="font-family:Arial, Helvetica, sans-serif;font-weight:500;font-size:16px;line-height:131%;color:#FFFFFF;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:3px;padding-right:0;padding-left:0;" ><a href="tel:+78005558322" style="text-decoration:none;color:#FFFFFF;" ><img src="https://f.d-services.ru/web_assets/icon-phone.png" alt="" style="max-width:100%;max-height:100%;" ><span style="padding-left:4px;" >8 (800) 555-83-22</span></a></p><p style="font-family:Arial, Helvetica, sans-serif;font-weight:500;font-size:12px;line-height:120%;color:#FFFFFF;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:3px;padding-right:0;padding-left:0;" ><a href="mailto:support@d-services.ru" style="text-decoration:none;color:#FFFFFF;" ><img src="https://f.d-services.ru/web_assets/icon-mail.png" alt="" style="max-width:100%;max-height:100%;margin-bottom:-3px;" ><span style="padding-left:4px;" >support@d-services.ru</span></a></p><p style="font-family:Arial, Helvetica, sans-serif;font-weight:400;font-size:12px;line-height:120%;color:#ffffff;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:11px;padding-bottom:0;padding-right:0;padding-left:0;" >117105, г. Москва, вн. тер. г. муниципальный округ Нагорный, ш. Варшавское, д. 26, стр. 10, помещ. 1/3</p></div></td></tr></tbody></table></body></html>';

					const content = letter_header + html + letter_footer;

					document.getElementById('resultHTML').textContent = content;
					document.getElementById('letter_construct_input').style.display = 'none';
					document.getElementById('letter_construct_output').style.display = 'block';
				} else {
					this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Заголовок и текст не могут быть пустыми' });
				}
			},

			newLetter: function () {
				location.reload();
			},

			showPattern: function (e) {
				e.preventDefault();
				if(document.getElementById('pattern_block').style.display == 'block') {
					document.getElementById('pattern_block').style.display = 'none';
				} else if(document.getElementById('pattern_block').style.display == 'none') {
					document.getElementById('pattern_block').style.display = 'block';
				}
			},

			addErrorPattern: function (e) {
				document.getElementById('pattern_block').style.display = 'none';

				const content = '<h2 style="display: flex; align-items: center;"><img src="https://f.d-services.ru/web_assets/icon-error.png" alt="" style="max-width:100%;max-height:100%;vertical-align: middle;float: left"><strong style="color:rgb(0, 0, 0);vertical-align: -webkit-baseline-middle;margin-left: 10px;">Заголовок</strong></h2><p><br></p><p>Введите текст</p>';

				var objects = document.getElementsByClassName('ql-editor')
				for(var obj of objects) {
					obj.innerHTML = content;
				}
			},

			addRecoveryPattern: function (e) {
				document.getElementById('pattern_block').style.display = 'none';

				const content = '<h2 style="display: flex; align-items: center;"><img src="https://f.d-services.ru/web_assets/icon-success.png" alt="" style="max-width:100%;max-height:100%;vertical-align: middle;float: left"><strong style="color:rgb(0, 0, 0);vertical-align: -webkit-baseline-middle;margin-left: 10px;">Заголовок</strong></h2><p><br></p><p>Введите текст</p>';

				var objects = document.getElementsByClassName('ql-editor')
				for(var obj of objects) {
					obj.innerHTML = content;
				}
			},

			addInfoPattern: function (e) {
				document.getElementById('pattern_block').style.display = 'none';

				const content = '<h2 style="display: flex; align-items: center;"><img src="https://f.d-services.ru/web_assets/icon-info.png" alt="" style="max-width:100%;max-height:100%;vertical-align: middle;float: left"><strong style="color:#0481D6;vertical-align: -webkit-baseline-middle;text-align: right;margin-left: 10px;">Заголовок</strong></h2><p><br></p><p>Введите текст</p>';

				var objects = document.getElementsByClassName('ql-editor')
				for(var obj of objects) {
					obj.innerHTML = content;
				}
			},
		}
	})

</script>
